import React, { Fragment } from 'react';
import { notification } from 'antd';
import store from '../redux/configureReduxStore';

export const showNotifications = (data) => {
    if (data.crm_link.includes('/Lead_profile') && data.type === 'success') {
        store.dispatch({ type: 'FILTER_APP_NOTIFICATION', payload: data });
    } else {
        store.dispatch({ type: 'APP_NOTIFICATION', payload: data });
    }
    return (
        notification[data.type]({
            message: data.title,
            description:
    <Fragment>
        <h4>{data.msg}</h4>
        <div>To view this lead, click the link below:</div>
        <a href={data.crm_link}>View Lead</a>
    </Fragment>,
            placement: 'bottomRight',
        })
    );
};



// WEBPACK FOOTER //
// ./src/config/notifications.js